module.exports = __webpack_public_path__ + "static/img/book-qr-code.9e4a2921.jpg";